export const ProfitWithdrawTypeToCash = "ToCash";
export const ProfitWithdrawTypeToBalance = "ToBalance";
export const ProfitWithdrawTypeToBank = "ToBank";
export const ProfitWithdrawTypeDebtClaiming = "DebtClaiming";
export const DebtClaimTypeByCash = "ByCash";
export const DebtClaimTypeByBalance = "ByBalance";
export const DebtClaimTypeByProfit = "ByProfit";
export const DebtClaimTypeByBank = "ByBank";
export const DiscountToBalance = "Balance";
export const DiscountToDebt = "Debt";

export const FinancialOperationTypeWithdrawBalance = "Withdraw Balance";
export const FinancialOperationTypeClaimDebt = "Claim Debt";
export const FinancialOperationTypeWithdrawProfit = "Withdraw Profit";
export const FinancialOperationTypeDebitToCredit = "Debit to Credit";
export const FinancialOperationTypeApplyDiscount = "Apply Discount";
export const FinancialOperationTypeDebitToProfit = "Debit to Profit";
export const FinancialOperationTypeWithdrawExtraProfit =
  "Withdraw Extra Profit";
export const FinancialOperationTypeMoveBalance = "Move Balance";
export const FinancialOperationTypeClaimDebtByParentAgencyProfit =
  "Claim Debt By Parent Agency Profit";

export const WithdrawBalanceByCash = "Cash";
export const WithdrawBalanceByKuveytturk = "KuveytTurk";
export const WithdrawBalanceByAlBaraka = "AlBaraka";
export const WithdrawBalanceByIsBank = "IsBank";
export const WithdrawBalanceByServiceSystem = "ServiceSystem";

export const FinancialOperationTypes = [
  {
    id: 1,
    icon: <></>,
    text: FinancialOperationTypeClaimDebt,
  },
  {
    id: 2,
    icon: <></>,
    text: FinancialOperationTypeWithdrawProfit,
  },
  {
    id: 3,
    icon: <></>,
    text: FinancialOperationTypeWithdrawBalance,
  },
  {
    id: 4,
    icon: <></>,
    text: FinancialOperationTypeDebitToCredit,
  },
  {
    id: 5,
    icon: <></>,
    text: FinancialOperationTypeApplyDiscount,
  },
  {
    id: 6,
    icon: <></>,
    text: FinancialOperationTypeDebitToProfit,
  },
  {
    id: 7,
    icon: <></>,
    text: FinancialOperationTypeWithdrawExtraProfit,
  },
  {
    id: 8,
    icon: <></>,
    text: FinancialOperationTypeMoveBalance,
  },
  {
    id: 9,
    icon: <></>,
    text: FinancialOperationTypeClaimDebtByParentAgencyProfit,
  },
];
export const ProfitWithdrawTypes = [
  {
    id: 1,
    icon: <></>,
    text: ProfitWithdrawTypeDebtClaiming,
  },
  {
    id: 2,
    icon: <></>,
    text: ProfitWithdrawTypeToBalance,
  },
  {
    id: 3,
    icon: <></>,
    text: ProfitWithdrawTypeToBank,
  },
  {
    id: 4,
    icon: <></>,
    text: ProfitWithdrawTypeToCash,
  },
];
export const ExtraProfitWithdrawTypes = [
  {
    id: 1,
    icon: <></>,
    text: ProfitWithdrawTypeDebtClaiming,
  },
  {
    id: 2,
    icon: <></>,
    text: ProfitWithdrawTypeToBalance,
  },
  {
    id: 3,
    icon: <></>,
    text: ProfitWithdrawTypeToBank,
  },
  {
    id: 4,
    icon: <></>,
    text: ProfitWithdrawTypeToCash,
  },
];
export const DebtClaimTypes = [
  {
    id: 1,
    icon: <></>,
    text: DebtClaimTypeByProfit,
  },
  {
    id: 2,
    icon: <></>,
    text: DebtClaimTypeByBalance,
  },
  {
    id: 3,
    icon: <></>,
    text: DebtClaimTypeByCash,
  },
  {
    id: 4,
    icon: <></>,
    text: DebtClaimTypeByBank,
  },
];
export const ApplyDiscountTypes = [
  {
    id: 1,
    icon: <></>,
    text: DiscountToBalance,
  },
  {
    id: 2,
    icon: <></>,
    text: DiscountToDebt,
  },
];
export const WithdrawBalanceTypes = [
  {
    id: 1,
    icon: <></>,
    text: WithdrawBalanceByCash,
  },
  {
    id: 2,
    icon: <></>,
    text: WithdrawBalanceByKuveytturk,
  },
  {
    id: 3,
    icon: <></>,
    text: WithdrawBalanceByAlBaraka,
  },
  {
    id: 4,
    icon: <></>,
    text: WithdrawBalanceByIsBank,
  },
  {
    id: 5,
    icon: <></>,
    text: WithdrawBalanceByServiceSystem,
  },
];
